<template>
  <form data-vv-scope="data-group">
    <div class="row mb-5">
      <div class="col-md-12 mt-3 text-center">
        <div v-if="!showConfirm && !confirm">
          <p class="warning-confirmation" v-if="!group.isOffice">
            ¿Estás seguro de remover el grupo {{group.nombre}}?
          </p>
          <p class="warning-confirmation" v-if="group.isOffice">
            ¿Estás seguro de remover la oficina {{group.nombre}}?
          </p>
          <b-button
            variant="primary"
            @click="attemptRemoveGroup()"
            data-cy="remove"
          >
            Remover
          </b-button>
        </div>
        <div class="row" v-if="showConfirm">
          <div class="col-6">
            <p class="warning-confirmation" v-if="!group.isOffice">
              Vas a remover el grupo {{group.nombre}}
            </p>
            <p class="warning-confirmation" v-if="group.isOffice">
              Vas a remover la oficina {{group.nombre}}
            </p>
          </div>
          <div class="col-6">
            <div class="text-right">
              <b-button
                class="ml-3"
                variant="outline-secondary"
                @click="discardChanges()"
              >
                Mejor no
              </b-button>
              <b-button
                class="ml-3"
                variant="primary"
                @click="saveChanges()"
              >
                Si, seguro
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [],
  props: {
    action: {
      type: String,
      required: true
    },
    group: {
      type: Object
    }
  },
  data() {
    return {
      confirm: false,
      showConfirm: false,
      groupId: ''
    };
  },
  watch: {},
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Modals', [
      'modalName'
    ]),
    showModal: {
      get() {
        return this.modalName === 'modalUser';
      },
      set() {
        this.closeModal();
      }
    }
  },
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Empresas', [
      'removeGroupCompany'
    ]),
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async attemptRemoveGroup() {
      const isValid = await this.validateForm('data-group');
      if (!isValid) {
        return;
      }
      this.showConfirm = true;
    },
    async saveChanges() {
      const isValid = await this.validateForm('data-group');
      if (!isValid) {
        return;
      }
      await this.removeGroupCompany(
        { empresaIut: this.company.iut, groupId: this.group.id }
      );
      await this.$bvToast.toast(
        'Se ha realizado la acción correctamente',
        {
          title: 'Genial',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      this.$emit('close-action');
      this.showConfirm = false;
      this.confirm = true;
    },
    async discardChanges() {
      this.showConfirm = false;
      this.confirm = false;
    }
  },
  created() {
    this.confirm = false;
  }
};
</script>
<style scoped>
.warning-confirmation {
  text-align: center;
  background-color: #ff9800;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
}
</style>
